<template>
  <v-list>
    <v-list-subheader>
      <v-icon>mdi-history</v-icon>
      History
    </v-list-subheader>

    <!-- Display the active URL item first -->
    <v-list-item v-if="activeUrlItem">
      <UrlHistoryListItem
        :item="activeUrlItem"
        :allow-selection="false"
        :allow-deletion="false"
      />
    </v-list-item>

    <!-- Display the rest of the URLs -->
    <UrlHistoryListItem
      v-for="item in otherUrls"
      :key="item.baseUrl"
      :item="item"
      :remove-url="removeUrl"
      :allow-selection="true"
      :allow-deletion="true"
      @select-url="handleSelect"
    />
  </v-list>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useUrlHistoryStore } from '@/store/urlHistoryStore';
  import { useActiveUrlStore } from '@/store/activeUrlStore';
  import UrlHistoryListItem from './UrlHistoryListItem.vue';
  
  // emits the select-url event with the URL as a parameter that can be used by the parent component
  const emit = defineEmits<{ (e: 'select-url', url: string): void }>();

  const urlHistoryStore = useUrlHistoryStore();
  const activeUrlStore = useActiveUrlStore();

  const activeUrl = computed(() => activeUrlStore.activeUrl);
  const urls = computed(() => urlHistoryStore.urls);

  // Filter the active URL item
  const activeUrlItem = computed(() =>
    urls.value.find((url) => url.baseUrl === activeUrl.value)
  );

  // Get the other URLs that are not active
  const otherUrls = computed(() =>
    urls.value.filter((url) => url.baseUrl !== activeUrl.value)
  );

  const removeUrl = (baseUrl: string) => {
    urlHistoryStore.removeUrl(baseUrl);
  };

  function handleSelect(url: string) {
    activeUrlStore.setActiveUrl(url);   
    emit('select-url', url);            
  }
</script>
